import React from 'react';
import { X, Trash2, Plus, Minus, ShoppingCart } from 'lucide-react';

export default function CartDrawer({
  isOpen,
  setIsOpen,
  cartItems = [],
  removeFromCart,
  updateQty,
  handleCheckout,
  totalPrice,
}) {

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[430px] bg-[#f7f7f7] z-50 shadow-2xl transition-transform duration-300 flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >

        {/* HEADER */}
        <div className="flex items-center justify-between px-5 py-4 bg-white border-b sticky top-0 z-10">
          <div className="flex items-center gap-2">
            <ShoppingCart size={20} />
            <h2 className="text-lg font-semibold">Shopping Cart</h2>
          </div>

          <button
            onClick={() => setIsOpen(false)}
            className="p-2 rounded-full hover:bg-gray-100 transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* EMPTY */}
        {cartItems.length === 0 ? (

          <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
            <ShoppingCart size={60} className="text-gray-300 mb-4" />
            <h3 className="text-lg font-semibold text-gray-700">Your Cart is Empty</h3>
            <p className="text-sm text-gray-500 mt-1">Add products to continue shopping</p>
          </div>

        ) : (

          <>
            {/* ITEMS */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">

              {cartItems.map((item, index) => (

                <div
                  key={item.uniqueId || index}
                  className="bg-white border rounded-2xl p-3 flex gap-3 shadow-sm"
                >

                  {/* IMAGE */}
                  <div className="w-24 h-24 bg-gray-50 rounded-xl flex items-center justify-center overflow-hidden border">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-contain"
                    />
                  </div>

                  {/* DETAILS */}
                  <div className="flex-1">

                    <h3 className="text-sm font-medium text-gray-800 line-clamp-2">
                      {item.name}
                    </h3>

                    <p className="text-lg font-bold mt-2 text-black">
                      ₹{item.price}
                    </p>

                    {/* ACTIONS */}
                    <div className="flex items-center mt-4">

                      {/* QTY */}
                      <div className="flex items-center border rounded-full overflow-hidden">

                        <button
                          type="button"
                          onClick={() =>
                            updateQty(item.uniqueId, 'dec')
                          }
                          className="px-3 py-1 hover:bg-gray-100"
                        >
                          <Minus size={14} />
                        </button>

                        <span className="px-3 text-sm font-medium">
                          {item.qty}
                        </span>

                        <button
                          type="button"
                          onClick={() =>
                            updateQty(item.uniqueId, 'inc')
                          }
                          className="px-3 py-1 hover:bg-gray-100"
                        >
                          <Plus size={14} />
                        </button>

                      </div>

                      {/* DELETE */}
                      <button
                        type="button"
                        onClick={() =>
                          removeFromCart(item.uniqueId)
                        }
                        className="ml-auto text-red-500 hover:text-red-600 transition"
                      >
                        <Trash2 size={18} />
                      </button>

                    </div>

                  </div>

                </div>
              ))}

            </div>

            {/* FOOTER */}
            <div className="bg-white border-t p-5 sticky bottom-0">

              <div className="flex items-center justify-between mb-4">
                <span className="text-base font-medium">Subtotal</span>
                <span className="text-2xl font-bold">₹{totalPrice}</span>
              </div>

              <button
                type="button"
                onClick={handleCheckout}
                className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-full transition shadow-sm"
              >
                Proceed to Checkout
              </button>

            </div>
          </>
        )}

      </div>
    </>
  );
}